class SideAdvancedFilters {
  static async init () {
    if ($('#side-advanced-filters').length) return new SideAdvancedFilters()
  }

  constructor () {
    const dataQuery = $.parseJSON($('code[data-query-params]').attr('data-query-params') || '{}')
    this.listingsPath = (dataQuery.path || 'listings') + '?'
    delete dataQuery.path
    this.dataQuery = dataQuery

    this.bindEvents()
  }

  bindEvents () {
    const container = $('#side-advanced-filters')

    container.on('click', '.filters-group__header', $.proxy(this.onHeaderClick, this))
    container.on('click', '[id^="show_more_"]', $.proxy(this.onShowMoreClick, this))
    container.on('click', 'button[role*="button-apply"]', $.proxy(this.onApplyClick, this))
    container.on('click', 'button[role*="button-clear"]', $.proxy(this.onClearClick, this))

    $.each(['prices', 'years'], (index, formName) => {
      $('button#apply-' + formName).on('click', (e) => {
        e.preventDefault()

        window.location.href = this.listingsPath + $.param(this.dataQuery) + '&' + $('form#' + formName).serialize()
      })

      $('button#clear-' + formName).on('click', (e) => {
        e.preventDefault()

        const params = Object.assign({}, this.dataQuery)
        delete params['min_' + formName.slice(0, -1)]
        delete params['max_' + formName.slice(0, -1)]

        window.location.href = this.listingsPath + $.param(params)
      })
    })
  }

  onHeaderClick (e) {
    const header = $(e.currentTarget)
    if (!header.find('.filters-group__control').length) return

    header.find('.fa-chevron-up, .fa-chevron-down').toggleClass('fa-chevron-up fa-chevron-down')
    header.find('.fa-plus, .fa-minus').toggleClass('fa-plus fa-minus')
    header.siblings('.filters-group__body').toggleClass('hidden')
  }

  onShowMoreClick (e) {
    const button = $(e.currentTarget)

    button.siblings('ul').addClass('list-unstyled--full')
    button.remove()
  }

  onApplyClick (e) {
    e.preventDefault()

    const button = $(e.currentTarget)
    const fieldName = button.data('field')
    const params = this.paramsWithoutFilter(fieldName)

    $('form#body_spec_' + button.data('form-id')).serializeArray().forEach((formField) => {
      params.filters.push({
        field: fieldName,
        operation: formField.name,
        value: formField.value
      })
    })

    window.location.href = this.listingsPath + $.param(params)
  }

  onClearClick (e) {
    e.preventDefault()

    const params = this.paramsWithoutFilter($(e.currentTarget).data('field'))

    window.location.href = this.listingsPath + $.param(params)
  }

  paramsWithoutFilter (fieldName) {
    const params = Object.assign({ filters: [] }, this.dataQuery)
    params.filters = params.filters.filter((filter) => filter.field !== fieldName)

    return params
  }
}

export default SideAdvancedFilters
